/* A COACH PROPOSES A LIBRARY ITEM (her ask, 2026-10-22: "after you have
 * brainstormed … would you like me to save it to the library").
 *
 * The coach writes one delimited block at the end of a reply; the screen shows
 * it as a card — "Save to my Library" / "Keep chatting" — and nothing is saved
 * until she presses Save. Brill proposes, she keeps (screen-pattern rule 4).
 * The block never shows in the chat: cleanMessageContent strips it.
 *
 *   <<<LIBRARY_ITEM:story>>>
 *   Title: The retreat that made me COO
 *   The text, any number of lines.
 *   Answer: (objection only) how she answers it
 *   <<<LIBRARY_END>>>
 *
 * Kinds are the Library's own four (utils/library.js LIBRARY_KINDS). A block
 * with any other kind, or no text, is not a proposal — read as nothing, so a
 * malformed block costs a card, never a junk row in her Library.
 * The instruction that writes this lives in api/_lib/prompts.js COACH_RULES;
 * the delimiters below must match it (coachLibrary.test.js).
 */
import { LIBRARY_KINDS, STORY_MINE } from "./library";

export const LIBRARY_BLOCK_RE = /<<<LIBRARY_ITEM:\s*([a-z]+)\s*>>>([\s\S]*?)<<<LIBRARY_END>>>/i;
export const LIBRARY_BLOCK_ALL_RE = /<<<LIBRARY_ITEM:[^>]*>>>[\s\S]*?(<<<LIBRARY_END>>>|$)/gi;

/** The proposal in a reply, as a Library record ready to save — or null. */
export function parseLibraryProposal(content) {
  const m = String(content || "").match(LIBRARY_BLOCK_RE);
  if (!m) return null;
  const kind = m[1].toLowerCase();
  if (!LIBRARY_KINDS.some((k) => k.id === kind)) return null;
  let body = m[2].replace(/\r/g, "").trim();
  let title = "";
  const t = body.match(/^Title:\s*(.+)\n?/i);
  if (t) { title = t[1].trim(); body = body.slice(t[0].length).trim(); }
  let answer = "";
  const a = body.match(/\n?^Answer:\s*([\s\S]*)$/im);
  if (a) { answer = a[1].trim(); body = body.slice(0, a.index).trim(); }
  if (!body) return null;
  const item = { kind, text: body };
  if (title) item.title = title;
  if (kind === "objection" && answer) item.answer = answer;
  /* A story from a coach is hers unless she said otherwise; the Library's
     "whose" is what tells a tool it may tell it in the first person. */
  if (kind === "story") item.whose = STORY_MINE;
  return item;
}

/** The same item already in her Library, by its words — so a card that comes
 *  back after a refresh opens what she saved instead of saving it twice. */
export function alreadySaved(items = [], item) {
  if (!item) return null;
  const norm = (s) => String(s || "").replace(/\s+/g, " ").trim();
  return (items || []).find((it) => it.kind === item.kind && norm(it.text) === norm(item.text)) || null;
}
